import React from 'react';
import clsx from 'clsx';
import { List, ListItem, ListItemIcon, ListItemText, withStyles } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomButton from '../Button/Button'

const WIDTH = 250;

const styles = theme => ({
    root: {
        width: WIDTH + 'px',
        border: '1px solid ' + theme.inputfields.select.menu.border,
        backgroundColor: 'white'
    },
    menu: {
        position: 'fixed',
        zIndex: 99,
        backgroundColor: 'white',
    },

    buttonIcon: {
        '& svg': {
            marginRight: '0 !important'
        }
    }
})

class ListAction extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick);
    }

    handleClick = (e) => {
        if (this.node && !this.node.contains(e.target)) { 
            this.setOpen(false)
            return;
        }
        e.stopPropagation();
    }

    setOpen = (state) => {
        this.setState({
            open: state
        })
    }

    setMenuStyle = (placement) => {
        let rect = {}
        let buttonIcon = document.getElementsByClassName('ListActionButtonIcon')[0]
        if (buttonIcon !== undefined) {
            rect = buttonIcon.getBoundingClientRect();
            switch (placement) {
                case 'bottom-left':
                    return { marginLeft: (rect.width - WIDTH) + 'px' };
                case 'bottom':
                    return { marginLeft: ((rect.width - WIDTH) / 2) + 'px' };
                case 'bottom-right':
                    return { }
                default: 
                    return { }
            }
        }
    }

    renderListItems = (listItems) => {
        if (!listItems) return

        let listItemsRendered = []
        for (const listItem of listItems) {
            
            let listItemContent = ''
            if (listItem.content) {
                listItemContent = listItem.content
            } else {
                listItemContent = <React.Fragment>
                    <ListItemIcon>
                        {listItem.icon}
                    </ListItemIcon>
                    <ListItemText {...listItem.text} />
                </React.Fragment>
            }

            listItemsRendered.push(
                <ListItem {...listItem.props}>
                    {listItemContent}
                </ListItem>
            )
        }
        return listItemsRendered
    }

    render() {
        const { classes, mainButtonComponent, wrapperClass, mainButtonClass, placement, listItems } = this.props;

        const menuStyle = this.setMenuStyle(placement);
        const listItemsRendered = this.renderListItems(listItems)

        let mainButton = mainButtonComponent
        
        if (!mainButton) {
            mainButton = <CustomButton
                size={'medium'}
                color={'secondary'}
                className={clsx(classes.buttonIcon, 'ListActionButtonIcon', mainButtonClass)}
            >
            <FontAwesomeIcon icon={['fas', 'ellipsis-h']} />
        </CustomButton>
        }

        return (<div className={wrapperClass}>
                <div onClick={() => this.setOpen(true)}>
                    {mainButton}
                </div>
                {this.state.open 
                ? <div ref={node => this.node = node} className={classes.menu} style={ menuStyle }>
                    <div className={ classes.root }>
                        <List component="nav" aria-label="main mailbox folders">
                           { listItemsRendered }
                        </List>
                    </div>
                </div> 
                : null}
            </div>
        );
    }
}
export default withStyles(styles)(ListAction);